import { PDFDocument, StandardFonts, rgb, PDFPage, PDFFont } from 'pdf-lib';
import {
  COORDS_RISOLUZIONE,
  FONT_SIZE_RISOLUZIONE,
} from './pdfCoordinatesRisoluzione.ts';
import { getPolizzaRisolta } from './getPolizzaRisolta.ts';

const COLOR_TXT = rgb(0, 0, 0);

function oggiFormattato(): string {
  return new Intl.DateTimeFormat('it-IT', {
    timeZone: 'Europe/Rome',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(new Date());
}

function formatDateISO(d?: string | null): string {
  return d ? new Date(d).toLocaleDateString('it-IT') : '';
}

export async function generaPdfRisoluzione(idPolizza: string): Promise<Blob> {
  const p = await getPolizzaRisolta(idPolizza);

  const buffer = await fetch('/pdf/modelloann.pdf').then(r => r.arrayBuffer());
  const pdf    = await PDFDocument.load(buffer);

  const page   = pdf.getPage(0);
  const fontR  = await pdf.embedFont(StandardFonts.Helvetica);
  const fontB  = await pdf.embedFont(StandardFonts.HelveticaBold);

  /* --- Dati dinamici --- */
  const agenzia         = p.agente?.agenzia?.nome ?? '';
  const dataOggi        = oggiFormattato();
  const dataRisoluzione = formatDateISO(p.data_risoluzione);
  const nominativo      = p.nome_cliente || p.cognome_cliente
    ? `${p.nome_cliente ?? ''} ${p.cognome_cliente ?? ''}`.trim()
    : p.ragione_sociale ?? '';
  const cfPiva = p.codice_fiscale ?? p.partita_iva ?? '';

  /* Riga agenzia + data → unica stringa allineata a destra */
  const agenziaDataText = `${agenzia}, ${dataOggi}`;
  const textWidth = fontR.widthOfTextAtSize(agenziaDataText, FONT_SIZE_RISOLUZIONE);

  page.drawText(agenziaDataText, {
    x: COORDS_RISOLUZIONE.agenziaData.x - textWidth,
    y: COORDS_RISOLUZIONE.agenziaData.y,
    size: FONT_SIZE_RISOLUZIONE,
    font: fontR,
    color: COLOR_TXT,
  });

  /* Campi dinamici */
  page.drawText(p.targa ?? '', {
    x: COORDS_RISOLUZIONE.targa.x,
    y: COORDS_RISOLUZIONE.targa.y,
    size: FONT_SIZE_RISOLUZIONE,
    font: fontB,
    color: COLOR_TXT,
  });
  page.drawText(dataRisoluzione, {
    x: COORDS_RISOLUZIONE.data_risoluzione.x,
    y: COORDS_RISOLUZIONE.data_risoluzione.y,
    size: FONT_SIZE_RISOLUZIONE,
    font: fontB,
    color: COLOR_TXT,
  });
  page.drawText(nominativo, {
    x: COORDS_RISOLUZIONE.nominativo.x,
    y: COORDS_RISOLUZIONE.nominativo.y,
    size: FONT_SIZE_RISOLUZIONE,
    font: fontB,
    color: COLOR_TXT,
  });
  page.drawText(cfPiva, {
    x: COORDS_RISOLUZIONE.cf_piva.x,
    y: COORDS_RISOLUZIONE.cf_piva.y,
    size: FONT_SIZE_RISOLUZIONE,
    font: fontB,
    color: COLOR_TXT,
  });

  const bytes = await pdf.save();
  return new Blob([new Uint8Array(bytes)], { type: 'application/pdf' });
}
